export default __webpack_public_path__ + "static/media/est-barreiro.c850774a.png";